import {AppDispatch} from '../redux/rootReducer';
import {ErrorJsonHandlerMap} from './requestErrorHandler';
import {postJsonData} from './requests';

export const requestPasswordReset = (mail: string, dispatch: AppDispatch) => {
    const url = `api/public/1.0/password/request-password-reset`;
    return postJsonData(url, mail, dispatch, true);
};

export const setNewPassword = (token: string, password: string, dispatch: AppDispatch, statusHandler: ErrorJsonHandlerMap = {}) => {
    const url = 'api/public/1.0/password/set-new-password';
    return postJsonData(url, JSON.stringify({token: token, password: password}), dispatch, false, statusHandler);
};
